import React, { ComponentPropsWithoutRef, forwardRef } from 'react';
import { styled } from '../../theme';
import { GDSCustomizableComponent } from '../../types';
import { GenesisCoreInspector } from '../../test-utils/genesis-core-inspector';

export interface GDSImageProps
  extends ComponentPropsWithoutRef<'img'>,
    GDSCustomizableComponent {}

const DISPLAY_NAME = 'Image';

const StyledImage = styled('img', {});

export const Image = forwardRef<HTMLImageElement, GDSImageProps>(
  (
    {
      className,
      alt = '',
      'data-testid': testId = `GDS-${DISPLAY_NAME}`,
      ...props
    },
    ref,
  ) => (
    <GenesisCoreInspector displayName={DISPLAY_NAME}>
      <StyledImage
        alt={alt}
        className={['GDS-image', className].join(' ')}
        ref={ref}
        data-testid={testId}
        {...props}
      />
    </GenesisCoreInspector>
  ),
);

Image.displayName = DISPLAY_NAME;
